var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.cssClass},[_c('label',[_c('input',{attrs:{"type":"radio","id":_vm.id},domProps:{"value":_vm.optionValue,"checked":_vm.isChecked},on:{"change":_vm.onInput}}),_vm._v(" "+_vm._s(_vm.label)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }